import { t } from 'i18next';
import { EventTimePreference } from 'src/enums/eventTimePreference.enum';

export interface Item {
  id: string;
  eventId: string | undefined;
  eventName: string | undefined;
  eventTypeId: string | undefined; // Ontology
  audience: string | undefined;
  timeplanTemplateId: string | undefined; // Ontology
  eventColor: string | undefined;
  anchorEventTime: Date | undefined;
  OSEId: string | undefined; // Ontology
  OCEId: string | undefined; // Ontology
  ODE: string | undefined; // Ontology
  direvalId: string | undefined; // Ontology
  organizationTemplate: string | undefined;
  ETE3EventObjectives: string | undefined;
  anchorEventLocationId: string | undefined;
  hymotsDB: number | undefined;
  timePreference: EventTimePreference;
}

export interface EventPropsType {
  activeKey: string;
  defaultKey: string;
}

export const deleteConfirmTitles = () => ({
  title: t('general.deleteConfirmTitle'),
  okText: t('general.no'),
  cancelText: t('general.yes'),
});
